<template>
  <div id="done_set_status" class="page-container md-layout-column">

    <md-dialog-alert
      :md-active.sync="error.show"
      :md-title="error.title"
      :md-content="errorMessage(error.error)"
      md-confirm-text="Ok"/>

    <md-content>

      <md-field :class="messageClass" v-if="order.clientFullPrice!==0">
        <md-icon>input</md-icon>
        <label for="payment_type">Тип оплаты</label>
        <md-select v-model="statusOptions.payment_type" name="payment_type" id="payment_type" required>
          <md-option value="CASH">Наличными</md-option>
          <md-option value="CARD">Картой</md-option>
        </md-select>
        <span class="md-error"> Необходимо выбрать тип оплаты </span>
      </md-field>

      <md-field :class="messageClass" v-else>
        <label for="payment_type">Тип оплаты</label>
        <md-select v-model="statusOptions.payment_type" name="payment_type" id="payment_type" required disabled>
          <md-option value="CASH">Предоплата</md-option>
        </md-select>
      </md-field>


      <md-content v-if="needScanQRItems">

        <md-toolbar>
          <span class="md-title">Позиции по заказу</span>
        </md-toolbar>

        <md-card v-for="(item, index) in order.items">

          <template v-if="needScanQR(item)">

            <template v-if="!item.trueMarkScanned">
              <md-button class="md-accent md-raised" @click="scanButton(item.Id)">
                Необходимо отсканировать QR code
              </md-button>
            </template>
            <template v-if="item.trueMarkScanned">
              <md-field @click.native="scanButton(item.Id)">
                <label>QR code </label>
                <md-input :value="item.trueMarkScanned" readonly/>
              </md-field>
            </template>

            <stream-barcode-reader ref="qr" v-if="qrItemSelect.item_id === item.Id" @decode="codeScanned">
            </stream-barcode-reader>
          </template>

          <md-card-header>
            <div class="md-title">{{item.Name}}</div>
            <div class="md-subhead">Номер: {{index}}, id: {{item.Id}}, Кол-во: {{item.Count}}</div>
          </md-card-header>
        </md-card>

        <md-field>
          <label>Фото чека</label>
          <md-file accept="image/*" @change="loadPhoto($event)"/>
        </md-field>

        <md-field>
          <label>Номер чека</label>
          <md-input v-model="checkNumber"/>
        </md-field>

      </md-content>

      <md-field>
        <label>Фактическая дата доставки: </label>
        <md-input :value="currentDate" readonly/>
      </md-field>

      <md-field>
        <label>Получить с покупателя: </label>
        <md-input :value="order.clientFullPrice" readonly/>
      </md-field>

      <md-field>
        <label>Получено с покупателя: </label>
        <md-input :value="order.clientFullPrice" readonly/>
      </md-field>

      <md-field>
        <label>Комментарий: </label>
        <md-textarea v-model="statusOptions.comment"/>
      </md-field>

      <md-dialog-confirm
        :md-active.sync="showSetStatusDialog"
        md-title="Установить статус?"
        :md-content="dialogMsg"
        md-confirm-text="Установить"
        md-cancel-text="Отмена"
        @md-cancel="onCancel"
        @md-confirm="setStatus"/>
      <md-button class="md-raised md-accent" @click="createDialog">Установить статус</md-button>
    </md-content>
  </div>
</template>

<script>
  // import VueQrReader from 'vue-qr-reader/dist/lib/vue-qr-reader.umd.js';
  import {StreamBarcodeReader} from "vue-barcode-reader";

  export default {
    name: "Done",
    props: ['order'],
    data() {
      return {
        showSetStatusDialog: false,
        lightInputs: false,
        dialogMsg: '',
        photo: '',
        checkNumber: '',
        statusOptions: {
          payment_type: '',
          date_fact_delivery: '',
          comment: '',
        },
        qrItemSelect: {
          item_id: null,
        },
      }
    },
    mounted() {
      if (this.$props.order.clientFullPrice === 0) {
        this.statusOptions.payment_type = "CASH";
      }
    },
    created: function () {
      this.statusOptions.date_fact_delivery = new Date();
    },
    methods: {
      errorMessage(error) {
        return this.$store.getters.getErrorMessage(error)
      },
      setStatus() {
        let app = this;

        if (app.needScanQRItems) {

          let formData = new FormData();

          formData.append("token", "HekI3aFDF83dLpa92Kdrb2EsrrwfH");
          formData.append("payload", JSON.stringify({order_id: this.$props.order.order.Id}));
          formData.append("file", app.photo);

          let request = new XMLHttpRequest();
          request.open("POST", "http://storage.topdelivery.ru/file/upload");
          request.onload = function () {
            app.$store.getters.getWSConnectState.ws.send(JSON.stringify({
              event: "setOrderDoneStatus",
              id: app.$props.order.order.Id,
              payment_type: app.statusOptions.payment_type,
              date_fact_delivery: app.statusOptions.date_fact_delivery,
              comment: app.statusOptions.comment,
              items: app.$props.order.items,
              photo_id: JSON.parse(request.response).id,
              check_number: app.checkNumber,
            }));
          };
          request.onerror = function () {
            console.log(request.response);
          };
          request.send(formData);
        } else {
          app.$store.getters.getWSConnectState.ws.send(JSON.stringify({
            event: "setOrderDoneStatus",
            id: app.$props.order.order.Id,
            payment_type: app.statusOptions.payment_type,
            date_fact_delivery: app.statusOptions.date_fact_delivery,
            comment: app.statusOptions.comment,
            items: app.$props.order.items,
          }));
        }
      },
      onCancel() {
        this.showSetStatusDialog = false
      },
      createDialog() {
        this.dialogMsg = `Установить заказу № ${this.$props.order.order.Id} финальный статус "Полностью выполнен?"`;
        this.showSetStatusDialog = true
      },
      needScanQR(item) {
        return item.trueMarkRequired > 0
      },
      codeScanned(code) {
        for (let item of this.$store.getters.getOrder.items) {
          if (item.Id === this.qrItemSelect.item_id) {
            item.trueMarkScanned = code;
            this.qrItemSelect.item_id = null
          }
        }
      },
      scanButton(key) {
        if (this.qrItemSelect.item_id === key) {
          this.qrItemSelect.item_id = null
        } else {
          this.qrItemSelect.item_id = key
        }
      },
      loadPhoto(e) {
        this.photo = e.target.files[0];
      }
    },
    computed: {
      currentDate() {
        const options = {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'};
        return this.statusOptions.date_fact_delivery.toLocaleDateString(undefined, options)
      },
      error() {
        let err = this.$store.getters.getErrorByMethod('setStatus');
        if (err.show) this.lightInputs = true;
        return err
      },
      messageClass() {
        return {
          'md-invalid': this.lightInputs
        }
      },
      needScanQRItems() {
        for (let item of this.$store.getters.getOrder.items) {
          if (this.needScanQR(item)) {
            return true
          }
        }
        return false
      },
      user() {
        return this.$store.getters.getUser
      }
    },
    components: {
      StreamBarcodeReader
    }
  }
</script>

<style scoped>
  .md-card {
    width: 300px;
    margin: 4px 4px 4px 4px;
    display: inline-block;
    vertical-align: top;
    word-wrap: break-word;
  }

  .md-button.md-accent.md-raised.md-theme-default {
    font-size: 13px;
  }

  .scanRow {
    background: rgba(0, 255, 0, 0.40);
  }

  .md-content {
    padding-left: 0px;
  }
</style>


<style>
  #done_set_status .scanner-container {
    height: 240px;
    width: 240px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Status/Done.vue